import Joi from 'joi';

import { TransactionTypeEnum } from '../../../transactions/enums/transaction-type.enum';

/**
 * Schema for send payment link validation
 */
export const sendPaymentLinkSchema = (options?: {
	maxAmount?: number;
	maxExpirationDays?: number;
	requireRecipientEmail?: boolean;
	requireDescription?: boolean;
}) => {
	let amountSchema = Joi.number().positive().required();
	if (options?.maxAmount != null) {
		amountSchema = amountSchema.max(options.maxAmount);
	}

	let expirationDaysSchema = Joi.number().integer().min(1).optional();
	if (options?.maxExpirationDays != null) {
		expirationDaysSchema = expirationDaysSchema.max(options.maxExpirationDays);
	}

	let recipientEmailSchema = Joi.string().email().allow('', null);
	if (options?.requireRecipientEmail) {
		recipientEmailSchema = Joi.string().email().required();
	}

	let descriptionSchema = Joi.string().allow('', null);
	if (options?.requireDescription) {
		descriptionSchema = Joi.string().min(1).max(100).required();
	}

	return Joi.object({
		amount: amountSchema,
		expirationDays: expirationDaysSchema,
		description: descriptionSchema,
		recipientEmail: recipientEmailSchema,
		payerFirstName: Joi.string().allow('', null),
		payerLastName: Joi.string().allow('', null),
		transactionType: Joi.string()
			.valid(TransactionTypeEnum.RECEIPT, TransactionTypeEnum.DEPOSIT)
			.optional(),
	}).unknown(true);
};
